import { render, staticRenderFns } from "./UserInbox.vue?vue&type=template&id=5d77eaa2"
import script from "./UserInbox.vue?vue&type=script&lang=js"
export * from "./UserInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d77eaa2')) {
      api.createRecord('5d77eaa2', component.options)
    } else {
      api.reload('5d77eaa2', component.options)
    }
    module.hot.accept("./UserInbox.vue?vue&type=template&id=5d77eaa2", function () {
      api.rerender('5d77eaa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/UserInbox.vue"
export default component.exports